<template>
	<footer class="footer">
		<div class="content">
			<div class="top">
				<div class="fuwu">
					<h3>服务</h3>
					<ul>
						<li @click="toServe">网站建设</li>
						<li @click="toServe">软件开发</li>
						<li @click="toServe">电商平台建设</li>
						<li @click="toServe">APP开发</li>
						<li @click="toServe">微信/小程序开发</li>
						<li @click="toServe">网络运营</li>
						<li @click="toServe">互联网运营</li>
						<li @click="toServe">媒介传播</li>
					</ul>
				</div>
				<div class="fangan">
					<h3>解决方案</h3>
					<ul>
						<li @click="toProgramme">移动电商类</li>
						<li @click="toProgramme">社区类</li>
						<li @click="toProgramme">智慧城市类</li>
						<li @click="toProgramme">家政类</li>
						<li @click="toProgramme">政务类</li>
						<li @click="toProgramme">新媒体咨询类</li>
					</ul>
				</div>
				<div class="about">
					<h3>关于我们</h3>
					<ul>
						<li @click="toCases">服务案例</li>
						<li @click="toAbout">公司简介</li>
						<li @click="toAbout">服务项目</li>
						<li @click="toAbout">联系我们</li>
						<li @click="toAbout">合作伙伴</li>
					</ul>
				</div>
				<div class="joinus">
					<h3>加入我们</h3>
					<p>
						这个行业贩卖的是头脑<br />所以我们对有些想法的人异常渴望<br />如果你有
						提着脑袋来见<br />简历邮箱：hr@junhebrand.com
					</p>
				</div>
				<div class="content">
					<h3>联系我们</h3>
					<p>
						邮箱：junhe@junhebrand.com<br />郑州市金水区东明路金成大厦A座3层<br />北京市朝阳区未来时大厦4楼<br />上海市浦东新区科苑路华强大厦6楼<br />投诉建议
					</p>
				</div>
			</div>
			<div class="bottom">
				<p>Copyright@ 2010-2025郑州君和电子商务有限公司</p>
				<!-- <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">豫IPC18029061号-3</a> -->
				<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">豫ICP备18029061号-3</a>
				
				<!-- <a href="https://beian.miit.gov.cn" target="_blank">豫ICP备18029061号-5</a> -->
			</div>
		</div>
	</footer>
</template>

<script>
	export default {
		name: "Footer",
		methods: {
			toServe() {
				window.open("https://www.junhebrand.com/service", "_blank");
			},
			toProgramme() {
				window.open("https://www.junhebrand.com/programme", "_blank");
			},
			toCases() {
				window.open("https://www.junhebrand.com/cases", "_blank");
			},
			toAbout() {
				window.open("https://www.junhebrand.com/about", "_blank");
			}
		},
	};
</script>

<style lang="less" scoped>
	.footer {
		width: 100%;
		height: 560px;
		background-color: #17171a;
		overflow: hidden;

		.content {
			width: 1440px;
			height: 100%;
			margin: 0 auto;

			.top {
				width: 1440px;
				height: 440px;
				border-bottom: 1px solid #2f2f31;
				display: flex;
				justify-content: space-around;
				align-items: center;

				.fuwu,
				.fangan,
				.about {
					width: 260px;
					height: 440px;
				}

				.joinus,
				.content {
					width: 330px;
					height: 440px;
				}

				h3 {
					width: 200px;
					height: 20px;
					font-size: 20px;
					font-weight: 400;
					color: #ffffff;
					line-height: 30px;
					margin: 80px 0 20px 0;
				}

				li,
				p {
					height: 30px;
					font-size: 16px;
					font-weight: 400;
					color: #666666;
					line-height: 30px;
				}

				li:hover {
					color: red;
					cursor: pointer;
				}
			}

			.bottom {
				width: 1440px;
				height: 120px;
				margin: 0 auto;
				display: flex;
				justify-content: space-between;

				p {
					width: 606px;
					height: 120px;
					font-size: 16px;
					font-weight: 400;
					color: #666666;
					line-height: 120px;
				}

				a {
					display: block;
					width: 200px;
					height: 120px;
					font-size: 16px;
					font-weight: 400;
					color: #666666;
					line-height: 120px;
				}
			}
		}
	}
</style>
